import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const MatchIcon = ({ fill, ...props }: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      aria-label="placeholder-event-icon"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2 7.99961C11.2 8.66235 11.7373 9.19961 12.4 9.19961C13.0628 9.19961 13.6 8.66235 13.6 7.99961C13.6 7.33687 13.0628 6.79961 12.4 6.79961C11.7373 6.79961 11.2 7.33687 11.2 7.99961ZM12.4 10.3996C13.7255 10.3996 14.8 9.32509 14.8 7.99961C14.8 6.67413 13.7255 5.59961 12.4 5.59961C11.2817 5.59961 10.342 6.36447 10.0756 7.39961L5.9244 7.39961C5.65798 6.36447 4.71832 5.59961 3.60001 5.59961C2.27453 5.59961 1.20001 6.67413 1.20001 7.99961C1.20001 9.32509 2.27453 10.3996 3.60001 10.3996C4.71832 10.3996 5.65798 9.63475 5.9244 8.59961L10.0756 8.59961C10.342 9.63475 11.2817 10.3996 12.4 10.3996ZM3.60001 6.79961C4.26275 6.79961 4.80001 7.33687 4.80001 7.99961C4.80001 8.66235 4.26275 9.19961 3.60001 9.19961C2.93727 9.19961 2.40001 8.66235 2.40001 7.99961C2.40001 7.33687 2.93727 6.79961 3.60001 6.79961Z"
        fill={fill ?? 'currentColor'}
      />
    </SvgWrapper>
  );
};
